import { useMutation } from 'react-query';
import { getWorkOrderFinancialReceipt } from './work-order-synthetic-total-cost.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { AxiosError } from 'axios';
import arrayBufferParse from '@/utils/functions/arrayBufferParse';

interface Report {
  timestamp: string;
  status: number;
  error: string;
  path: string;
  message: string;
}

export function useWorkOrderSyntheticTotalCostReport() {
  return useMutation(getWorkOrderFinancialReceipt, {
    onSuccess() {
      notification.success({
        message: 'Relatório de orçamento gerado com sucesso!',
      });
    },

    onError(error: AxiosError<Report>) {
      const response = arrayBufferParse<Report>(error.response?.data);

      notificationError(response);
    },
  });
}
